import { BaseRequest } from "../base-request";

export class ResultRequest extends BaseRequest {
  constructor(input: { sessionId: string }) {
    super();
    this.sessionId = input.sessionId;
  }

  public sessionId: string;
}
